import React from 'react';

const TableHeader = ({ columns }) => {
  return (
    <thead className="thead-custom">
      <tr>
        {columns.map((col, index) => (
          <th
            key={index}
            className="align-middle"
            style={{
              width: col.width || 'auto',
              textAlign: col.align || 'left',
            }}
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
